var UITextarea = (function ($) {

    UITextarea = function () {
        var that = this;

        // DOM

        // CONST
        that.class = {
            focus: 'focus',
            not_empty: 'not-empty',
            error: 'error',
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UITextarea.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UITextarea.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.textarea', function (e) {
            var $target = $(e.target),
                $textarea_wrapper = $(this),
                $textarea = $textarea_wrapper.find('textarea');

            if (!$target.is('textarea') && !$textarea.is(':disabled') && !$textarea.is(':read-only')) {
                $textarea.focus();
            }
        });

        $.sa.$document.on('focus', '.textarea textarea', function (e) {
            var $textarea = $(this),
                $textarea_wrapper = $textarea.parents('.textarea');

            if ($textarea.is(':read-only')) {
                e.preventDefault();
                return false;
            }

            if (!!$textarea.val()) {
                $textarea_wrapper.addClass(that.class.not_empty);
            }
            $textarea_wrapper.addClass(that.class.focus);
        });

        $.sa.$document.on('focusout', '.textarea textarea', function () {
            var $textarea = $(this),
                $textarea_wrapper = $textarea.parents('.textarea');

            $textarea_wrapper.removeClass(that.class.focus);
        });

        $.sa.$document.on('input', '.textarea textarea', function () {
            var $textarea = $(this),
                $textarea_wrapper = $textarea.parents('.textarea'),
                $error = $textarea_wrapper.find('.error');

            this.style.height = 'auto';
            this.style.height = (this.scrollHeight + 2) + 'px';

            $textarea_wrapper.removeClass(that.class.error).toggleClass(that.class.not_empty, !!$textarea.val());
            $error.text('');
        });
    };

    return UITextarea;
})($);
